package com.iptvplayer.web.ui.screen

import androidx.compose.runtime.*
import com.iptvplayer.shared.presentation.viewmodel.AuthViewModel
import com.iptvplayer.web.ui.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun LoginScreen(authVm: AuthViewModel, onGoRegister: () -> Unit, onBack: (() -> Unit)? = null) {
    val state by authVm.state.collectAsState()
    var username by remember { mutableStateOf("") }
    var password by remember { mutableStateOf("") }

    AuthShell("Welcome back", "Sign in to your account", onBack = onBack) {
        ErrorText(state.error)
        Field("Username", username, "your username") { username = it; authVm.clearError() }
        Field("Password", password, "••••••••", password = true) { password = it; authVm.clearError() }
        Div(attrs = { style { property("margin-top", "6px") } }) {
            PrimaryButton(
                text = if (state.isLoading) "Signing in…" else "Sign in",
                enabled = !state.isLoading && username.isNotBlank() && password.isNotBlank(),
            ) { authVm.login(username.trim(), password) }
        }
        Div(attrs = {
            style {
                property("margin-top", "16px"); property("text-align", "center")
                property("color", Theme.textDim); property("font-size", "14px")
            }
        }) {
            Text("No account? ")
            A(href = "#", attrs = { onClick { it.preventDefault(); onGoRegister() } }) { Text("Create one") }
        }
    }
}
